import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IRangBuocActionTypes } from "../../action-types/category/IRangBuocActions";
import { IRangBuocReducer } from "../../reducer-model/category/IRangBuocReducer";

const iniState: IRangBuocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  rangBuocs: [],
};
export const rangBuocReducer = (
  state: IRangBuocReducer = iniState,
  action: IRangBuocActionTypes
): IRangBuocReducer => {
  switch (action.type) {
    case "RANG_BUOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "RANG_BUOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        rangBuocs: action.payload,
      };
    case "RANG_BUOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "RANG_BUOC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "RANG_BUOC_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "RANG_BUOC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        rangBuocEditing: action.payload,
      };
    case "RANG_BUOC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "RANG_BUOC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "RANG_BUOC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "RANG_BUOC_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "RANG_BUOC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    default:
      return state;
  }
};
